<template>
  <div id="documenting">
    <projectTable :operateColumns="operateColumns" ref="projectTable" :extraQuery="extraQuery" :extraSearch="extraSearch"></projectTable>
    <detail-modify 
      :projectData="projectData" 
      :medal="medal" 
      @medal_ch="change_medal" 
      :editType="editType" 
      @refresh=refresh
      @reviseManager="reviseManager"
      @addManager="addManager"
      ref="detailModify">
    </detail-modify>
    <Modal v-model="editGroupVisible" title="包组编辑" width="1100px":mask-closable="false">
      <edit-project :projectData="projectData" status="extraEdit"></edit-project>
    </Modal>
  </div>
</template>

<script>
import projectTable from '@/components/projectTable'
import ajax from '@/lib/ajax'
import util from '@/lib/util'
import DetailModify from "./detailModify.vue"
import EditProject from '@/views/documentation/editProject'
import { getProjectPermission } from "@/lib/projectPermission"

export default {
  name: 'projectModify',
  data() {
    return {
      medal: false,
      operateColumns: [
        {
          title: '项目修改',
          align: 'center',
          width: 260,
          render: (h, params) => {
            let state = false
            if (params.row.projectState === '项目结项') {
              state = true
            }
            return h('div', {
              style: {
                textAlign: 'center'
              }
            }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: state
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.projectData = params.row
                      this.editGroupVisible = true
                    }
                  }
                }, '包组及应收'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    // disabled: state
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.medal_show(params.row, 'member')
                    }
                  }
                }, '项目人员'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      this.medal_show(params.row, 'info')
                    }
                  }
                }, '项目信息'),
              ])
          }
        }
      ],
      // editProject: 'projectList',
      projectData: {},
      // 项目状态筛选
      extraQuery: {
        status: ' and projectState != "项目取消"',
        rolePermission: ''
      },
      editGroupVisible: false,
      extraSearch: {
        searchModify: true
      },
      editType: ''
    }
  },
  components: {
    projectTable,
    DetailModify,
    EditProject
  },
  methods: {
    medal_show(project, type) {
      this.projectData = project
      this.medal = true
      this.editType = type
    },
    change_medal(val) {
      //改变模态框的值
      this.medal = val
    },
    refresh() {
      this.$refs.projectTable.searchProject()
    },
    reviseManager(val) {
      this.projectData.am = val
      this.$refs.detailModify.addManagerVisible = false
    },
    addManager(val) {
      this.projectData.am += `,${val}`
      this.$refs.detailModify.addManagerVisible = false
    }
  }
}
</script>
